import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { IPoint } from '../../../../../infrastructure/module/independent/graphic/point/point.interface';
import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';
import { IBaseFrameProperty } from './base/base.interface';

export type IMultiModelFrameMap = Map<IBaseModel['key'], Partial<IFrame> | null>; // key为model.key, value为model待更新的frame
export type IValueMap = Map<IBaseModel['key'], number>; // key为model.key, value为model待更新的height

export interface IFrameProperty extends IBaseFrameProperty {
    /**
     * 转换元素的变更信息：由相对与slide改为相对于自身的父元素
     */
    convertFrameOnSlideToSelf(frameOfSlide: IFrame): IFrame;
    /**
     * 计算元素解组合之后在slide上的包裹矩形
     */
    boundingRectOnSlide(currentFrame?: IFrame, isOperation?: boolean): IFrame;
    /**
     * slide上的坐标相对于当前元素的坐标
     * @param points
     */
    pointToElement(originalPoint: IPoint, isOperating: boolean): IPoint
    /**
     * 当前坐标相对于slide的坐标
     * @param points
     */
    pointOnSlide(originalPoint: IPoint, isOperating: boolean): IPoint
    /**
     * 计算元素解组合之后在slide上的外层frame，即当存在旋转时返回能够包裹元素旋转后的矩形
     */
    outerFrameOnSlide(): IFrame
}

export interface IFrame extends IRect, IRotateAndFlip {}

export interface ITextFrame extends IRect {
    rotate?: number;
}

export interface IRotateAndFlip {
    flipV?: number;
    flipH?: number;
    rotate?: number;
}

export interface IScaleInfo {
    scaleX: number;
    scaleY: number;
}

/**
 * 大小边界值
 */
export interface IRectEdge {
    left: number;
    top: number;
    right: number;
    bottom: number;
}

export const MODES = {
    TOP_LEFT: 'TOP_LEFT',
    TOP: 'TOP',
    TOP_RIGHT: 'TOP_RIGHT',
    RIGHT: 'RIGHT',
    BOTTOM_RIGHT: 'BOTTOM_RIGHT',
    BOTTOM: 'BOTTOM',
    BOTTOM_LEFT: 'BOTTOM_LEFT',
    LEFT: 'LEFT',
    MOVE: 'MOVE',
};
export type MODES = typeof MODES[keyof typeof MODES];
